import { AnonymousUploadInitResponse, FileChunk, UploadAnonymousHolterFileV2Options } from "../types";

export interface AnonymousHolterUploaderContext {
  initData: AnonymousUploadInitResponse;
  chunks: FileChunk[];
  options: UploadAnonymousHolterFileV2Options;
}

export abstract class AnonymousHolterUploader {
  protected readonly initData: AnonymousUploadInitResponse;
  protected readonly chunks: FileChunk[];
  protected readonly options: UploadAnonymousHolterFileV2Options;
  private readonly maxUploadAttempts = 3;

  constructor(context: AnonymousHolterUploaderContext) {
    this.initData = context.initData;
    this.chunks = context.chunks;
    this.options = context.options;
  }

  abstract upload(): Promise<unknown>;

  protected reportProgress(index: number) {
    this.options.onProgress?.((100 * (index + 1)) / this.chunks.length);
  }

  protected async uploadWithRetry<T>(operation: () => Promise<T>): Promise<T> {
    let lastError: unknown;

    for (let attempt = 1; attempt <= this.maxUploadAttempts; attempt++) {
      try {
        return await operation();
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError;
  }
}
